import React from 'react';
import './about.css';

const About = () => {
  return (
    <div className="about-container">
       <div className="banner">
        <img src="/images/slider1.jpg" alt="Banner" className="banner" />
      </div>
      <h1>पतसंस्थेबद्दल</h1>
     <p>xtyyqqd बचत गटातुन जिजाई अर्बन को-ऑप. क्रेडिट सोसा. लि. जत या पतसंस्थेची निर्मिती झाली. दि. 05/02/2024 रोजी 
      संस्थापक श्री सुरेश एम. सायगांव साहेब व चेअरमनसो सौ सुप्रिया गणेश काळे (कोळी) यांनी 550000/- भांडवल आणि 500 
      सभासदांसह याची सुरुवात केली. यशस्वी उद्योजक घडवणे महिला सशक्तिकरण करणे, महिला उद्योजक घडवणे असे अनेक संकल्प 
      ठेऊन आम्ही कार्यरत आहोत. आपली प्रगती व आर्थिक पत वाढवण्यासाठी आम्ही सदैव आपल्या सेवेत आहोत. अतिशय छोट्या 
      स्वरूपात असलेला या रोपट्याच आज वटवृक्षात रुपांतर झालेले आहे. आपुलकीची सेवा आणि खूप मोठी विश्वासाची थाप या जोरावर 
      संस्थेने नुकताच 3 कोटीच्या एकत्रित व्यवसायाचा टप्पा पार केला आहे. सर्वोत्तम व्यवस्थापन, विश्वासार्हता, नवीनतम-तंत्रज्ञान आणि 
      सामाजिक बांधिलकी हे सर्व जिजाई अर्बनच्या यशमागील रहस्य आहेत. तुमच्यासाठी सर्वोत्तम साध्य करण्यासाठी आम्ही आमचे सर्वोत्तम 
      देणे सुरू ठेवू.</p>
      <p>समाजातील प्रत्येक घटकाला आर्थिक स्वातंत्र्य मिळवून देण्याच्या उद्देशाने सुरु करण्यात आलेली संस्था महाराष्ट्र शासन अंतर्गत रजिस्टर्ड 
      आहे (रजि.क्र.एस.ए.एन/जी.ए.टी/आर.एस.आर./सी.आर./२१२५/२०२४ दि.०५/०२/२०२४) दिलेल्या सर्व नियम व अटींचे येथे 
      काटेकोरपणे पालन केले जाते. तुमच्या कष्टाच्या कमाईला सुरक्षित ठेऊन त्यावर जास्तीत जास्त परतावा मिळण्याच्या हेतूने संस्थेमध्ये 
      अनेक लाभदायी ठेव योजना उपलब्ध आहेत.</p>
      <p>ग्राहकांना तत्पर सेवा देण्याकरिता सर्व कर्मचारी अहोरात्र कार्यरत आहे. तत्पर आणि ग्राहकाभिमुख सेवा देण्याकरिता आधुनिक 
      तंत्रज्ञानाचा योग्य वापर केला जातो. ग्राहकांना QR Code, NEFT/RTGS/IMPS इ. सेवा उपलब्ध आहेत.</p>

    
      <h2>🏢 संचालक मंडळ यादी</h2>
          <table className="officials-table">
        <thead>
          <tr>
            <th>नाव</th>
            <th>पद</th>
          </tr>
        </thead>
        <tbody>
          <tr><td>मा.श्री. सचिन विलास माळी</td><td>चेअरमन</td></tr>
          <tr><td>मा.श्री. मनोज बाजीराव पोळ</td><td>व्हा. चेअरमन</td></tr>
          <tr><td>मा. डॉ. बाबासाहेब काशिराम माळी </td><td>संचालक</td></tr>
          <tr><td>मा.श्री. सुनिल बाळासाहेब कुंभार </td><td>संचालक</td></tr>
          <tr><td>मा.श्री शरद विलास माळी</td><td>संचालक</td></tr>
          <tr><td>मा.श्री. तुकाराम आबा गडदे</td><td>संचालक</td></tr>
          <tr><td>मा.श्री. प्रविण विलास माळी</td><td>संचालक</td></tr>
          <tr><td>मा.श्री. रेवाण्णा महादेव माळी</td><td>संचालक</td></tr>
          <tr><td>मा.श्री. सुरेंद्र निंगाप्पा सरनाईक </td><td>संचालक</td></tr>
          <tr><td>मा. सौ. शोभा दत्तात्रय कोरे </td><td>संचालिका</td></tr>
          <tr><td>मा. सौ. पद्मिनी नारायण शिंदे </td><td>संचालिका</td></tr>
          <tr><td>मा. श्री. बसवराज गंगाधर माळी </td><td>सचिव</td></tr>
        </tbody>
      </table>
    </div>
  );
};

export default About;
